/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Evgenij Tyan
 * @author Yakov Gushchin
 * @version 1.1.1
 * @since 1.0.0
 */
import get from 'lodash/get';
import moment from 'moment';

import { IFormValues } from './components/CreateInquiryForm/CreateInquiryForm';
import {
    ETopicAttrDataType,
    ETopicAttrVisibility,
    ITopicCustomerAttr,
    ITopicDictionary,
    ITopicDictionaryValue,
} from './types/createInquiryTypes';

export const getCustomAttrs = (list: ITopicCustomerAttr[], dictionaries: ITopicDictionary[]) => {
    return list.filter(
        (attr: ITopicCustomerAttr) => {
            return attr.declaration.visibility !== ETopicAttrVisibility.HIDDEN
                && attr.declaration.dataType !== ETopicAttrDataType.OAPI_VALUE
                && attr.declaration.dataType !== ETopicAttrDataType.DB_QUERY;
        },
    )
        .map(
            (attr: ITopicCustomerAttr) => {
                const attrItem = { ...attr };
                if (attrItem.declaration.dataType === ETopicAttrDataType.DICTIONARY) {
                    const dict = dictionaries.find((dict: ITopicDictionary) => dict.customAttrId === attrItem.id);
                    if (dict) {
                        attrItem.optionsList = dict.values.map((value: ITopicDictionaryValue) => {
                            return {
                                label: value.name,
                                value: value.id,
                            };
                        });
                    }
                }
                return attrItem;
            },
        );
};

export const getInitValue = (attr: ITopicCustomerAttr) => {
    switch (attr.declaration.dataType) {
        case ETopicAttrDataType.BOOL:
            return false;
        case ETopicAttrDataType.NUMBER:
            return null;
        case ETopicAttrDataType.DICTIONARY:
            if (attr.optionsList && attr.optionsList.length) {
                return attr.optionsList[0].value;
            }
            return undefined;
        default:
            return '';

    }
};

export const getResultValue = (attr: ITopicCustomerAttr, values: IFormValues) => {
    const attrValue = get(values, attr.key, '');
    switch (attr.declaration.dataType) {
        case ETopicAttrDataType.DICTIONARY :
            return { id: attrValue };
        case ETopicAttrDataType.BOOL:
            return { value: attrValue ? 1 : 0 };
        case ETopicAttrDataType.DATE:
            return { value: moment(attrValue).format('x') };
        default:
            return { value: attrValue };
    }
};
